import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
export var Locale = /*#__PURE__*/function (Locale) {
  Locale["English"] = "en";
  Locale["Spanish"] = "es";
  // for testing
  Locale["Chinese"] = "cn";
  return Locale;
}({});
export var getPrismicLocale = function getPrismicLocale(locale) {
  switch (locale) {
    case Locale.Spanish:
      return 'es-es';
    case Locale.English:
    default:
      return undefined;
    // default to english (actually en-au)
  }
};
var English = Locale.English,
  otherLocales = _objectWithoutProperties(Locale, ["English"]);
export var nonEnglishLocales = Object.values(otherLocales);